import Image from "next/image"
import { PRODUTO } from "@/lib/brand"
import { cn } from "@/lib/cn"

/*
 * MARK V — marca. Renderiza o símbolo (monograma V) e, opcionalmente, o
 * wordmark no estilo canônico (.markv-wordmark: Gontserrat 200 + tracking
 * largo). Assets reais em public/brand/ (handoff Claude Design).
 *
 * O wordmark escreve o nome do PRODUTO (Compass), não o da marca do Design
 * System: o símbolo é MARK V, o nome ao lado dele é o do app que a pessoa
 * abriu. Vem de src/lib/brand.ts porque já divergiu entre as telas.
 *
 * Variantes do símbolo:
 *   - gradient: lockup em gradiente verde (fundos claros).
 *   - white: símbolo branco (fundos escuros / superfícies de marca).
 *   - black: símbolo flat preto (uso monocromático).
 */

export type MarkVLogoVariant = "gradient" | "white" | "black"

const SYMBOL_SRC: Record<MarkVLogoVariant, string> = {
  gradient: "/brand/markv-symbol-gradient.png",
  white: "/brand/markv-symbol-white.png",
  black: "/brand/markv-symbol-black.png",
}

export type MarkVLogoProps = {
  variant?: MarkVLogoVariant
  /** Mostra o wordmark do produto ao lado do símbolo. */
  withWordmark?: boolean
  /** Altura do símbolo em px (largura = altura; o símbolo é quadrado). */
  size?: number
  /** Texto alternativo do símbolo. Vazio + aria-hidden quando há wordmark. */
  alt?: string
  className?: string
  wordmarkClassName?: string
}

export function MarkVLogo({
  variant = "gradient",
  withWordmark = false,
  size = 28,
  alt = PRODUTO,
  className,
  wordmarkClassName,
}: MarkVLogoProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <Image
        src={SYMBOL_SRC[variant]}
        width={size}
        height={size}
        alt={withWordmark ? "" : alt}
        aria-hidden={withWordmark || undefined}
        priority
      />
      {withWordmark && (
        <span className={cn("markv-wordmark text-sm", wordmarkClassName)}>{PRODUTO}</span>
      )}
    </span>
  )
}
